import { Star } from "lucide-react"

import { cn } from "@/lib/utils"

export function StarRating({ rating }: { rating: number | null }) {
  if (rating == null) return null
  return (
    <span className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={cn(
            "size-3",
            i <= rating
              ? "fill-amber-400 text-amber-400"
              : "fill-muted text-muted",
          )}
        />
      ))}
    </span>
  )
}
